import { Controller } from "stimulus"

export default class extends Controller {
  recipientLocked(event) {
    this.checkCompliance()
    this.checkInstructions()
  }

  checkInstructions() {
    if (this.selectedRecipientInstructions) {
      this.instructionsNotice.innerHTML = this.selectedRecipientInstructions
      this.instructionsNotice.show()
    }
  }

  checkCompliance() {
    if (this.selectedRecipientCompliance == 'permits') {
      this.inviteForm.show()
      this.sendEInvoiceForm.hide()
      this.copyRecipientAttributesToInvite()
    } else {
      this.inviteForm.hide()
      this.sendEInvoiceForm.show()
    }
  }

  get selectedRecipientCompliance() {
    var compliance = this.element.querySelector('.e-invoice-recipient-wrapper input:not([disabled])[name="document_e_invoice_delivery[compliance]"]')
    return compliance != null && compliance.value
  }

  get selectedRecipientInstructions() {
    var instructions = this.element.querySelector('.e-invoice-recipient-wrapper input:not([disabled])[name="document_e_invoice_delivery[instructions]"]')
    return instructions != null && instructions.value
  }

  get instructionsNotice() {
    return document.querySelector('#e-invoice-instructions')
  }

  get sendEInvoiceForm() {
    return document.querySelector('#e-invoice-send-to-approved-recipient')
  }

  get inviteForm() {
    return document.querySelector('#e-invoice-invite')
  }

  copyRecipientAttributesToInvite() {
    var external_id = this.element.querySelector('.e-invoice-recipient-wrapper input:not([disabled])[name="document_e_invoice_delivery[external_id]"]')
    document.querySelector('#e_invoice_invite_party_id').value = external_id && external_id.value

    var gln = this.element.querySelector('.e-invoice-recipient-wrapper input:not([disabled])[name="document_e_invoice_delivery[gln]"]')
    document.querySelector('#e_invoice_invite_gln').value = gln && gln.value

    var name = document.querySelector('#document_e_invoice_delivery_e_invoice_recipient')
    document.querySelector('#e_invoice_invite_name').value = name && name.value
  }
}